import { useEffect } from 'react';
import { companyInfo } from '../data/siteData';

export default function InstagramSection() {
  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://elfsightcdn.com/platform.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-20 bg-[#F2EFE9] border-t border-[#E2DDD3]">
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-12 space-y-2">
          <div className="w-[1px] h-8 bg-[#B5A897] mx-auto mb-3"></div>
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#B5A897] font-semibold block">
            SOCIALE MEDIER
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">
            FØLG OS PÅ INSTAGRAM
          </h2>
          <p className="text-xs text-stone-600 leading-relaxed font-sans max-w-md mx-auto">
            Få et indblik i vores hverdag på værkstedet, nyeste unika smykker, urerePARATIONER og stemningsbilleder fra butikken.
          </p>
        </div>

        {/* Elfsight Instagram Feed | Brønshøj Ure & Guld */}
        <script src="https://elfsightcdn.com/platform.js" async></script>
        <div className="elfsight-app-5eca29d1-8b1f-4425-80b7-335fa2573783" data-elfsight-app-lazy></div>

        {/* Instagram Action CTA */}
        <div className="text-center pt-10">
          <a
            href={companyInfo.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border border-[#0B132B] text-[#0B132B] hover:bg-[#0B132B] hover:text-white transition-all text-[11px] sm:text-xs tracking-[0.15em] sm:tracking-[0.25em] uppercase px-4 sm:px-8 py-3.5 rounded-none font-medium max-w-full text-center"
          >
            <i className="fa-brands fa-instagram text-sm" aria-hidden="true" />
            <span>FØLG @URE_OG_GULD PÅ INSTAGRAM</span>
          </a>
        </div>
      </div>
    </section>
  );
}
